(function () {
  function updateSubmenuOffset() {
    const header = document.querySelector('.gr-header__columns');
    if (!header) return;
    document.querySelectorAll('.gr-menu-list__list-item').forEach((item) => {
      const link = item.querySelector('.gr-menu-list__link[aria-haspopup="true"]');
      const submenuInner = item.querySelector('.gr-menu-list__submenu-inner');
      if (!link || !submenuInner) return;
      const headerRect = header.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      submenuInner.style.setProperty('--submenu-offset-left', `${linkRect.left - headerRect.left}px`);
    });
  }

  function initSubmenuOffset() {
    requestAnimationFrame(() => {
      updateSubmenuOffset();
      setTimeout(updateSubmenuOffset, 100);
      setTimeout(updateSubmenuOffset, 300);
    });
  }

  window.addEventListener('resize', updateSubmenuOffset);
  window.addEventListener('load', initSubmenuOffset);
  document.addEventListener('DOMContentLoaded', initSubmenuOffset);
  document.addEventListener('shopify:section:load', initSubmenuOffset);
  document.addEventListener('shopify:section:select', initSubmenuOffset);
  document.addEventListener('shopify:inspector:activate', initSubmenuOffset);
  document.addEventListener('shopify:inspector:deactivate', initSubmenuOffset);
  document.addEventListener('page:load', initSubmenuOffset);
  document.addEventListener('turbo:load', initSubmenuOffset);

  function initLandingAutoHideHeader() {
    if (!document.body.classList.contains('template-the-abyss')) return;

    const header = document.querySelector('#header-component.gr-header');
    if (!(header instanceof HTMLElement)) return;

    const SECTION_PROBE = () => Math.min(120, window.innerHeight * 0.15);

    let visible = false;
    let ticking = false;
    let lenisBound = false;

    const getY = () => {
      const engine = window.GrScroll?.get?.();
      const lenisY = engine?.lenis?.scroll;
      if (typeof lenisY === 'number') return lenisY;
      return window.scrollY || document.documentElement.scrollTop || 0;
    };

    const getSections = () =>
      Array.from(document.querySelectorAll('#MainContent > .shopify-section'));

    const getActiveSectionIndex = (y) => {
      const sections = getSections();
      if (!sections.length) return 0;

      const probe = y + SECTION_PROBE();
      let active = 0;

      for (let i = 0; i < sections.length; i += 1) {
        const top = sections[i].offsetTop;
        if (top <= probe) active = i;
        else break;
      }

      return active;
    };

    const isDrawerOpen = () =>
      Boolean(
        header.querySelector('details.menu-open, .menu-open, [aria-expanded="true"].gr-header__icon--menu')
      );

    const setVisible = (next) => {
      if (!next && isDrawerOpen()) next = true;
      if (visible === next) return;
      visible = next;
      header.setAttribute('data-gr-nav', next ? 'visible' : 'hidden');
    };

    const syncFromScroll = () => {
      const y = getY();
      const index = getActiveSectionIndex(y);
      setVisible(index >= 1);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        syncFromScroll();
      });
    };

    header.setAttribute('data-gr-nav', 'hidden');
    visible = false;
    syncFromScroll();

    window.addEventListener('scroll', onScroll, { passive: true });

    const bindLenis = () => {
      if (lenisBound) return;
      const lenis = window.GrScroll?.get?.()?.lenis;
      if (!lenis?.on) return;
      lenisBound = true;
      lenis.on('scroll', onScroll);
    };

    bindLenis();
    window.addEventListener('gr-scroll:ready', bindLenis);

    window.addEventListener('gr-hero:header-visible', (event) => {
      const detail = /** @type {CustomEvent} */ (event).detail;
      if (detail && typeof detail.visible === 'boolean') {
        setVisible(detail.visible);
      }
    });

    window.addEventListener('gr-hero:intro-complete', syncFromScroll);
    window.addEventListener('resize', syncFromScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLandingAutoHideHeader);
  } else {
    initLandingAutoHideHeader();
  }
})();
